import EventBus from "../services/event-bus";
import {useReducer, useEffect, useCallback, useRef, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText
} from "@mui/material";

const PUSH_ALERT = 'push-alert';
const REMOVE_ALERT = 'remove-alert';

export default function Alerts() {
    const [open, setOpen] = useState(false);
    const nextAlertIdRef = useRef(0);
    const [alerts, dispathAlertAction] = useReducer((state, action) => {
        switch (action.type) {
            case PUSH_ALERT:
                if (!action.alert.message) {
                    return state;
                }

                if (action.alert.options?.preventDuplicate && state.some(alert => alert.message === action.alert.message)) {
                    return state;
                }

                return [...state, action.alert];
            case REMOVE_ALERT:
                return state.filter(alert => alert.id !== action.alert.id);
            default:
                throw Error('Azione non disponibile');
        }
    }, [])

    const hasAlters = alerts.length > 0;
    const pushAlert = useCallback(event => {
        const action = {
            type: PUSH_ALERT,
            alert: {
                ...event.detail,
                id: ++nextAlertIdRef.current,
            }
        };
        dispathAlertAction(action);
        if (!hasAlters) {
            setOpen(true);
        }
    }, [dispathAlertAction, hasAlters, nextAlertIdRef]);

    const currentAlert = alerts.length > 0 ? alerts[0] : null;

    const handleClose = () => {
        setOpen(false);
        dispathAlertAction({type: REMOVE_ALERT, alert: currentAlert});
        if (alerts.length > 1) {
            setTimeout(() => setOpen(true), 400);
        }
    }

    /* eslint-disable */
    useEffect(() => {
        EventBus.subscribe('ALERT', pushAlert);
        return () => {
            EventBus.unsubscribe('ALERT', pushAlert);
        }
    }, []);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-message-title"
            aria-describedby="alert-message-description"
        >
            <DialogTitle id="alert-message-title">
                {currentAlert?.options?.variant == 'error' ? 'Errore!' : 'Attenzione!'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-message-description">
                    {currentAlert?.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
